import {cn} from '@chekin/guestapp-ui-kit';
import {Container, HeaderTitle, HeaderWrapper, LogoContainer, Title} from '../styled';
import {useLayoutMode} from 'hooks/useLayoutMode';
import usePropertyLinkInfo from 'hooks/guidebooks/usePropertyLinkInfo';
import {LanguageButton} from 'components/LanguageButton';

function Navbar() {
  const {logo, title} = usePropertyLinkInfo();
  const layoutMode = useLayoutMode();
  return (
    <HeaderWrapper className={cn('navbar', 'kiosko:h-[150px] kiosko:bg-white')}>
      <Container>
        <LogoContainer className="navbar__logo">
          {logo && (
            <img
              src={logo}
              alt="housing Logo"
              className={cn('navbar__logo-img', 'kiosko:w-[114px] kiosko:h-[114px]')}
            />
          )}
        </LogoContainer>
        <HeaderTitle className="navbar__title">
          <Title
            className={cn(
              'navbar__title-text',
              'kiosko:text-[35px] kiosko:leading-[56px] kiosko:ml-[20px]',
            )}
          >
            {title}
          </Title>
        </HeaderTitle>
        {layoutMode === 'kiosko' && <LanguageButton />}
      </Container>
    </HeaderWrapper>
  );
}

export {Navbar};
